import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationEN from './app/locales/en/common.json';
import translationFR from './app/locales/fr/common.json';

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
};

const supportedLanguages = Object.keys(resources);

export const dynamicPathDetector = {
  name: 'dynamicPath',
  lookup() {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname;
      const pathSegments = path.split('/');

      const foundLang = pathSegments.find((segment) =>
        supportedLanguages.includes(segment.toLowerCase()),
      );

      if (foundLang) {
        return foundLang.toLowerCase();
      }
    }
    return undefined;
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(dynamicPathDetector);

interface Options {
  order: Array<string>;
  lookupQuerystring: string;
  lookupCookie: string;
  lookupLocalStorage: string;
  lookupSessionStorage: string;
  lookupFromSubdomainIndex: number;
}

const options: Options = {
  order: [
    'dynamicPath',
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag',
    'subdomain',
  ],

  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupSessionStorage: 'i18nextLng',
  lookupFromSubdomainIndex: 0,
};

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    detection: options,
    resources,
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: false,
    load: 'languageOnly',
    lowerCaseLng: true,
    react: {
      useSuspense: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
